import styled from 'styled-components';
import { mixins } from '@jarvis/react-portal-addons';
import primitives from '@veneer/primitives';
import { Button as VeneerButton } from '@veneer/core';

export const Container = styled.div`
  position: relative;
  background-color: ${primitives.color.hpBlue7};
  box-sizing: border-box;
  height: fit-content;
  min-height: 392px;
  &.has-devices {
    min-height: 0;
  }
  padding: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 1660px;
  box-shadow: 0 2px 8px 2px #1A1A1A33;

  ${mixins.lg(`
    min-height: 536px;
    border-radius: 16px;
  `)}
`;

export const Title = styled.h3`
  margin: 20px 24px 20px 32px;
  color: ${primitives.color.white};
  font-weight: 700 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  opacity: 1;
  transition: opacity 0.3s ease-in-out;

  &.hide {
    ${mixins.lg(`
      opacity: 0;
    `)}
  }

  &:not(.has-devices) {
    max-width: 100%;
  }

  ${mixins.lg(`
    margin: 40px 0 48px 40px;
  `)}

  &.has-devices {
    position: absolute;
    top: 0;
    left: 0;
    margin-top: 84px;
    // 360px from notifications
    // 40px from left margin
    // 32px from right margin
    // 24px for spacing
    ${mixins.lg(`
      margin-top: 40px;
      max-width: calc(100% - 456px);
    `)}
    // 368px from notifications
    // 40px from left margin
    // 32px from right margin
    // 24px for spacing
    ${mixins.xl(`
      max-width: calc(100% - 464px);
    `)}
  }
`;

export const PrinterCarouselContainer = styled.div`
  margin: 0 0 24px 0;
  ${mixins.sm(`
    margin: 0 0 28px  0;
  `)}
  ${mixins.lg(`
    margin: 0 0 40px 0;
  `)}
`;

// TitleAndNotificationsWrapper works in conjunction with Title and NotificationsWidgetContainer
// Together they have a very particular transition and layout behavior
// Make sure to test ALL animations upon any changes to any of those 3 components
export const TitleAndNotificationsWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  &.has-devices {
    ${({ titleHeight = 0 }) => {
    // titleHeight = height of the title text
    // 64 = notifications height
    // 20 = top margin of the title
    // 20 = bottom margin of the title
    const height = titleHeight + 104;
    // titleHeight = height of the title text
    // 40 = top margin of the title
    // 48 = bottom margin of the title
    const heightLg = titleHeight + 88;
    return `
      min-height: ${height}px;
      ${mixins.lg(`
        min-height: ${heightLg}px;
        flex-direction: row-reverse;
      `)}
    `;
  }}}
`;

export const NotificationsWidgetContainer = styled.div`
  width: 100%;
  height: 100%;
  z-index: 9999;
  transition: max-height 0.3s ease-in-out;

  ${mixins.lg(`
    position: unset;
    z-index: unset;
    transition: width 0.3s ease-in-out, max-height 0.3s ease-in-out, height 0.3s ease-in-out;
    margin: 32px 32px 40px 32px;
  `)}

  &.collapsed {
    max-height: 64px;
    height: 64px;
    ${mixins.lg(`
      max-height: 64px;
      height: auto;
      animation: unset;
      width: 360px;
    `)}
  }

  &.expanded {
    position: fixed;
    max-height: calc(100vh - 76px);
    width: 100%;
    ${mixins.lg(`
      position: relative;
      max-height: 60vh;
      height: auto;
      width: 100%;
    `)}
  }
`;

export const MessageContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 70px 16px 86px 16px;
  ${mixins.sm(`
    margin: 80px 16px 96px 16px;
  `)}
  ${mixins.md(`
    margin: 82px 20px 102px 20px;
  `)}
  ${mixins.lg(`
    margin: 110px 32px 142px 32px;
  `)}
  ${mixins.xxxl(`
    margin: 122px 32px 154px 32px;
  `)}

  > p {
    color: ${primitives.color.white};
    text-align: center;

    &:first-child {
      margin-bottom: 4px;
    }
  }
`;

export const Button = styled(VeneerButton)`
  && {
    background-color: ${primitives.color.white};
    color: ${primitives.color.gray12};
    margin-top: 40px;

    &:hover {
      background-color: ${primitives.color.white};
      color: ${primitives.color.gray12};
    }
  }
`;
